








































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { VPopover } from 'v-tooltip'
import { mdiInformationOutline } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import { IPriceItem } from '~/assets/interfaces/price'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentPrice from '~/components/price/price.vue'
@Component({
  components: {
    ComponentPrice,
    VPopover,
    ComponentIcon,
  },
})
export default class ComponentProductDetailPrices extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) readonly prices: IPriceItem[]
  @Prop({ type: String, default: null }) readonly unit!: string

  private mdiInformationOutline = mdiInformationOutline
}
